<div class="warnings-panel" *ngIf="expanded && hasContent">

  <div class="panel-header">
    <div class="panel-title">
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        <path fill="currentColor" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
      <span>AVISOS DEL SISTEMA</span>
      <span class="count-pill">{{ totalCount }}</span>
    </div>
    <button class="btn secondary sm panel-close"
            (click)="onClose()"
            [appTooltip]="'Cerrar panel'">
      <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
        <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
      Cerrar
    </button>
  </div>

  <div class="panel-body">
    <div class="warning-group" *ngFor="let g of groups" [ngClass]="'severity-' + g.severity">
      <div class="group-header">{{ g.label }}</div>

      <div class="warning-card"
           *ngFor="let w of g.warnings; trackBy: trackByCode"
           [ngClass]="'severity-' + g.severity">
        <div class="card-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path fill="currentColor" [attr.d]="w.iconPath"/>
          </svg>
        </div>
        <div class="card-body">
          <div class="card-title">{{ w.label }}</div>
          <div class="card-details" *ngIf="w.details">{{ w.details }}</div>
          <div class="card-code" [appTooltip]="'Código del catálogo cerrado'">
            <code>{{ w.code }}</code>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
